export default __webpack_public_path__ + "static/media/calendar.5e30cda9.ico";